  <!--BANNER-->
  <div class="banner"></div>

  <!--EVENTS-->
  <section class="event-section">
    <div class="container-fluid">
      <div class="row d-flex flex-column justify-content-center align-items-center
            my-2 my-sm-1 my-md-1 my-lg-1 my-xl-1 ">
        <div class="py-0 py-sm-0 py-md-0 py-lg-2 py-xl-2">
      	  <img src="assets/img/stars.png" >
        </div>
        <div class="py-2 py-sm-0 py-md-0 py-lg-2 py-xl-2 text-center">
          <h4 class="hotel-name">IBEROSTAR VARADERO SELECTION HOTEL</h4>
        </div>
      </div>

      <div class="row d-flex justify-content-center my-2">
        <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
          <div class="d-flex justify-content-center">
            <img src="assets/img/immunopharmacology.png" class="size-immuno">
          </div>
        <!--IMMUNOPHARMACOLGY-->
          <div class="event-name">
            <label>
              IMMUNOPHARMACOLOGY 2023 is part of the Third Internacional Convention IMMUNOVACCIPHARMA 2023
            </label>
            <label class="duration">DURATION: JUNE 12 - 16, 2023</label>
          </div>

          <div>
            <div class="programs">
              <label>PROGRAMS</label>
            </div>
            <div class="row">
              <div class="col-12 col-sm-5 col-md-4 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/IMMUNOPHARMACOLOGY-2023.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">General Information</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>

              <div class="col-12 col-sm-7 col-md-8 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/Covid19_and_other_viral_diseases.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">Covid 19 and other viral diseases</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-sm-5 col-md-4 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/Poster_Session.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">Poster Session</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>

              <div class="col-12 col-sm-7 col-md-8 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/Neuropharmacology_and_Ataxias.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">Neuropharmacology and Ataxias</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>
            </div>

            <div class="row pb-2">
              <div class="col-12 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/Cancer_Immunopharmacology_Pharmacogenomics.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">Cancer Immunopharmacology & Pharmacogenomics</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>

              <div class="col-12 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/Immunology_Vaccine_and_Therapy_Infectious_Diseases_Symposium_Final.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">Immunology Vaccine and Therapy Infectious Diseases Symposium Final</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-auto col-xl-auto d-flex justify-content-center align-items-center p-3">
          <div class="v-line"></div>
        </div>

        <!--VACCIPHARMA-->
        <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
          <div class="d-flex justify-content-center">
            <img src="assets/img/vaccypharma.png">
          </div>

          <div class="event-name">
            <label>
              VACCIPHARMA 2023 is part of the Third Internacional Convention IMMUNOVACCIPHARMA 2023
            </label>
            <label class="duration">DURATION: JUNE 17 - 21, 2023</label>
          </div>

          <div>
            <div class="programs">
              <label>PROGRAM</label>
            </div>
            <div class="row">
              <div class="col-12 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/VACCIPHARMA.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">General Information</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>
            </div>

            <!--ABSTRACT BOOK-->
            <div class="programs">
              <label>ABSTRACT BOOK</label>
            </div>
            <div class="row">
              <div class="col-12 pb-2">
                <a class="download-doc" target="_blank" href="assets/documents/Abstract_Book.pdf">
                  <img src="assets/img/download.png" width="60px">
                  <div class="d-flex flex-column justify-content-center">
                    <label class="name-doc">Book</label>
                    <label class="download-text">Download</label>
                  </div>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>

  <!--SPONSORS-->
  <section class="sponsor-section">
    <div class="container">
      <div class="row d-flex justify-content-center my-2 mb-4">
        <h4 class="header-text">SPONSORSHIP</h4>
      </div>
      <div class="row">
        <ng-container *ngFor="let logo of logos">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 text-center p-4" >
            <img [src]="logo.src" />

          </div>
        </ng-container>
      </div>
    </div>
  </section>

  <!--SCIENTIFIC COMMITEE(S)-->
  <section class="committee-section">
    <div class="container-fluid">
      <div class="row d-flex justify-content-center px-2 py-4">
        <h4 class="header-text text-center">ORGANIZING / SCIENTIFIC COMMITTEE(S)</h4>
      </div>
      <div class="row d-flex justify-content-center my-0">

        <!-- IMMUNOPHARMACOLOGY -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
          <div class="container-fluid">
            <div class="row">
              <ng-container *ngFor="let comitee of commiteeImmunopharmacology">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-lg-6">
                  <ul >
                    <li>
                      <div class="d-flex flex-column">
                        <label class="committee-person">
                          {{comitee.name}}
                        </label>
                        <label class="committee-status">{{comitee.status}}</label>
                      </div>

                    </li>
                  </ul>
                </div>
              </ng-container>
            </div>
          </div>
        </div>

        <div class="col-12 col-sm-auto col-md-12 col-lg-auto col-xl-auto d-flex justify-content-center align-items-center p-3">
          <div class="v-line"></div>
        </div>

        <!-- VACCIPHARMA -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
          <div class="container-fluid">
            <div class="row">
              <ng-container *ngFor="let comitee of commiteeVaccipharma">
                <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-lg-6">
                  <ul >
                    <li>
                      <div class="d-flex flex-column">
                      <label class="committee-person">
                        {{comitee.name}}
                      </label>
                      <label class="committee-status">{{comitee.status}}</label>
                      </div>

                    </li>
                  </ul>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--REGISTER-->
  <section id="register" class="middle">
    <div class="color-overlay"></div>
    <div class="container" style="z-index: 1!important;position: relative;">
      <div class="row">
        <div class="col-12 d-flex flex-column align-items-center">

          <div>
            <label class="event-registration">Registration Deadline: May 4th, 2023 </label>
          </div>

          <div class="launch-time">
            <div class="d-flex flex-column align-items-center">
              <p class="number">{{dayImmunopharmacology}}</p>
              <p class="text">Days</p>
            </div>

            <div class="d-flex flex-column align-items-center">
              <p class="number">{{hoursImmunopharmacology}}</p>
              <p class="text">Hours</p>
            </div>

            <div class="d-flex flex-column align-items-center">
              <p class="number">{{minutesImmunopharmacology}}</p>
              <p class="text">Minutes</p>
            </div>

            <div class="d-flex flex-column align-items-center">
              <p class="number">{{secondsImmunopharmacology}}</p>
              <p class="text">Seconds</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
          <div class="col-12 d-flex align-items-center justify-content-center py-2">
            <label class="event">Contact: Mr. Sergio Pimentel </label>
          </div><div class="col-12 d-flex align-items-center justify-content-center py-2">
            <label class="event">Email: eventos@skediotravel.com </label>
          </div>

<!--        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column align-items-center py-2">-->
<!--          <label class="event">IMMUNOPHARMACOLOGY </label>-->
<!--          <a href="#" class="button-register"> REGISTER</a>-->
<!--        </div>-->

<!--        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column align-items-center py-2">-->
<!--          <label class="event">VACCIPHARMA </label>-->
<!--          <a href="#" class="button-register"> REGISTER</a>-->
<!--        </div>-->
      </div>
    </div>
  </section>

  <!--MAIN TOPIC-->
  <section class="topic-section">
    <div class="container">
      <div class="row d-flex justify-content-center px-2 py-4">
        <h4 class="header-text">MAIN TOPICS</h4>
      </div>
      <div class="row d-flex justify-content-center my-0">
        <div class="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
          <ul>
            <ng-container *ngFor="let topic of immunopharmacologyTopics">
              <li>
                <p class="topic">{{topic.name}}</p>
              </li>
            </ng-container>
          </ul>
        </div>
        <div class="col-12 col-sm-auto col-md-auto col-lg-auto col-xl-auto d-flex justify-content-center align-items-center p-3">
          <div class="v-line"></div>
        </div>
        <div class="col-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
          <ul>
            <ng-container *ngFor="let topic of vaccipharmaTopics">
              <li>
                <p class="topic">{{topic.name}}</p>
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <!--CALL OF ABSTRACTS-->
  <section class="abstract-section">
    <div class="container px-3">
      <div class="row d-flex justify-content-center px-2 py-4">
        <h4 class="header-text text-center">CALL OF ABSTRACTS</h4>
      </div>
      <div class="row d-flex justify-content-center my-0">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-lg-12">
            <ul>
              <ng-container *ngFor="let point of callAbstracts">
              <li>
                  <p class="topic">
                    {{point.topic}}
                  </p>
              </li>
              </ng-container>
            </ul>
          </div>
      </div>
    </div>
  </section>

  <!--LETTER FOR INVITATION-->
  <section class="topic-section">
    <div class="container px-3">
      <div class="row d-flex justify-content-center my-3">
        <h4 class="header-text">LETTER FOR INVITATION</h4>
      </div>
      <div class="row d-flex justify-content-center my-0">
        <div class="col-12">
          <p class="topic text-justify">
            The Organizers will provide a letter of invitation to participants, if requested,
            to make easier the steps for obtaining visa and funds. This letter does not necessarily
            imply any financial support from the Congress Organizing Committee.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!--PHOTOS-->
  <section class="photo-section" >
    <div class="container-fluid py-2">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end">
          <img src="assets/img/cover.png" class="photo-reserve">
        </div>

        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
          <img src="assets/img/meet_room.png" class="photo-reserve">
        </div>
      </div>
    </div>
  </section>

  <!--CONTACT-->
  <section class= "contact-section">
    <div class="container">
      <div class="row d-flex justify-content-center my-4">
        <h4 class="header-text">Contact Person</h4>
      </div>
      <div class="row mb-2">
        <ng-container *ngFor="let contact of contacts">
        <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
          <!-- IMG        -->
          <div>
            <img src="{{contact.img}}" style="width: 100%">
          </div>
          <!-- CONTACTS -->
          <div class="d-flex flex-column my-2 my-sm-2 my-md-2 my-lg-2 my-xl-2 align-items-center">
            <label class="name-contact">{{contact.name}}</label>
            <label class="email-contact">{{contact.email}}</label>
            <label class="name-contact">Scientify Issue</label>
            <label class="event-contact">Event: {{contact.event}}</label>
          </div>
        </div>
        </ng-container>
      </div>
    </div>
  </section>


  <app-home-footer></app-home-footer>
